module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetMedium.766efcc.jpg";